// 手机端调试工具
let vconsole = null
export const showVconsole = () => {
  if (vconsole) return
  const Vconsole = require('vconsole')
  vconsole = new Vconsole()
}
